<script setup>
import { onMounted } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { useWebSiteStore } from '@/stores/web-site.store'

const props = defineProps({
  modelValue: {
    type: [Number, String, null],
    required: false,
    default: null,
  },
})

const emit = defineEmits(['update:modelValue'])

const i18n = getI18n()
const webSiteStore = useWebSiteStore()

onMounted(async () => {
  await webSiteStore.fetchCountriesAsync({ all: true }, true)
})

const optionLabel = (opt) => opt?.code ? `${opt.code} - ${opt.name}` : opt?.name
</script>
<template>
  <q-select
    :model-value="props.modelValue"
    :options="webSiteStore.getLocalizedCountries()"
    :label="i18n.t('common.country')"
    option-value="id"
    :option-label="optionLabel"
    emit-value
    map-options
    clearable
    @update:model-value="(val) => emit('update:modelValue', val)"
  />
</template>
